// /src/components/StudentTestSelector.js
import React, { useState } from "react";
import STSStyles from "../styles/components/StudentTestSelector.module.css";
import InstructionsHost from "./InstructionsHost";

const StudentTestSelector = ({ testsAvailable = [], onStartTest }) => {
    const [selectedId, setSelectedId] = useState(null);

    const formatDate = (d) => {
        if (!d) return "";
        const date = new Date(d);
        if (isNaN(date)) return String(d);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };


    return (
        <div className={STSStyles.container}>
            <h2 className={STSStyles.title}>Choose Your Test</h2>

            {testsAvailable.length === 0 && (
                <div className={STSStyles.empty}>No tests available.</div>
            )}

            {testsAvailable.map((test) => {
                const isCompleted = !!test.completed;
                const isSelected = selectedId === test.test_id;

                return (
                    <div
                        key={test.test_id}
                        className={`${STSStyles.card} ${
                            isSelected ? STSStyles.selected : ""
                        }`}
                        onClick={() => setSelectedId(test.test_id)}
                    >
                        <h3 className={STSStyles.name}>{test.test_name}</h3>
                        <p className={STSStyles.desc}>{test.description}</p>

                        {isSelected ?
                            <div className={STSStyles.testInstructions}>
                                <InstructionsHost
                                    testKey={test.test_id === 1 ? "writing" : "speaking"}
                                />
                                <div className={STSStyles.beginBox}>
                                    <button className={STSStyles.beginButton} onClick={() => onStartTest(test)}>Begin Test</button>
                                </div>
                            </div> : ""}

                        {isCompleted ? (
                            <p className={STSStyles.completed}>
                                Test Completed: {formatDate(test.completed)}
                            </p>
                        ) : ( <></>
                            // <button
                            //     className={isSelected ? STSStyles.take_test_button : STSStyles.hidden}
                            //     onClick={(e) => {
                            //         e.stopPropagation();
                            //         setSelectedId(test.test_id);
                            //         onTakeTest?.(test);
                            //     }}
                            //     disabled={isCompleted}
                            // >
                            //     Take This Test
                            // </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default StudentTestSelector;
